import { ref } from "vue";
import type { DeliveryCapSettingUiState } from "../types";

/**
 * 画面UI状態の一元管理
 * ダイアログ表示/非表示、オーバーレイ、処理フラグ、タブ・モード、選択状態フラグを管理する
 */
export const useDeliveryCapSettingUiState = (): DeliveryCapSettingUiState => {
  // エラー系ダイアログ
  const errdialog = ref(false);
  const errMessage = ref("");
  const validErrdialog = ref(false);
  const capMessage = ref("");

  // ローディング
  const overlay = ref(false);

  // 処理フラグ（0: 閲覧, 1: 編集）
  const processFlag = ref(0);

  // モード（"shop" / "group"）
  const mode = ref("shop");

  // タブインデックス（0: 店舗, 1: グループ）
  const model = ref(0);

  // パネル開閉状態
  const panel = ref<number[]>([0]);

  // 更新確認/完了ダイアログ
  const confirmDialog = ref(false);
  const completeDialog = ref(false);

  // グループ確認ダイアログ
  const groupConfirmDialog = ref(false);

  // 配達情報確認ダイアログ
  const deliveryTimeConfirmDialog = ref(false);

  // 選択状態フラグ
  const selectShopFlg = ref(false);
  const selectAreaFlg = ref(false);
  const selectGroupFlg = ref(false);
  const selectGroupIdFlg = ref(false);

  // 初回グループ便自動セットフラグ
  const setIdFlg = ref(false);

  return {
    errdialog,
    errMessage,
    validErrdialog,
    capMessage,
    overlay,
    processFlag,
    mode,
    model,
    panel,
    confirmDialog,
    completeDialog,
    groupConfirmDialog,
    deliveryTimeConfirmDialog,
    selectShopFlg,
    selectAreaFlg,
    selectGroupFlg,
    selectGroupIdFlg,
    setIdFlg,
  };
};
